module.exports = __webpack_public_path__ + "static/media/xray-training-lateral-flex2.a0df415f.png";